import { useCallback } from 'react';

import { clearUserTokenCookies } from 'commons/localStorage';
import useResetUserData from './useResetUserData';

const useLogoutClient = () => {
  const resetUserData = useResetUserData();

  const logoutClient = useCallback(() => {
    resetUserData();
    clearUserTokenCookies();
  }, [resetUserData]);

  return logoutClient;
};

export default useLogoutClient;
